import React, { Component } from "react";
import { Link } from "react-router-dom";
import BackendClient from "../../BackendClient";

export default class extends Component {
  state = {
    widgetTextMap: new Map()
  };

  componentWillUnmount() {
    this.isCancelled = true;
  }

  componentDidMount() {
    !this.isCancelled &&
      BackendClient.getWidgetText({ title: "frontend.layouts.bottom" })
        .fetchJson()
        .then(res => {
          const widgetTextMap = new Map(
            (res || []).map(({ key, body }) => [key, body])
          );
          !this.isCancelled && this.setState({ widgetTextMap });
        });
  }

  getWidgetText = key => this.state.widgetTextMap.get(key) || "";

  renderWidgetBlock = (type, blockKey, props = {}) => {
    const __html = this.getWidgetText(blockKey) || "";
    return React.createElement(type, {
      ...props,
      dangerouslySetInnerHTML: { __html }
    });
  };

  render() {
    const { renderWidgetBlock: getBlock } = this;
    return (
      <div className="footer">
        <div className="container">
          <div className="footer-upper">
            <div className="phone-wrapper">
              {getBlock("div", "frontend.layouts.bottom.phone", {
                className: "phone"
              })}
              {getBlock("div", "frontend.layouts.bottom.phoneText", {
                className: "label-custom"
              })}
            </div>
            <div className="contact-wrapper">
              {getBlock("div", "frontend.layouts.bottom.email")}
              {getBlock("ul", "frontend.layouts.bottom.links", {
                className: "links"
              })}
            </div>
            <div className="social-wrapper">
              {getBlock("div", "frontend.layouts.bottom.labelCustom", {
                className: "label-custom"
              })}
              {getBlock("div", "frontend.layouts.bottom.linkSocial", {
                className: "socials"
              })}
            </div>
          </div>
          <div className="footer-bottom">
            {getBlock("div", "frontend.layouts.bottom.copyright", {
              className: "copyright"
            })}
            <div className="sign">
              {getBlock("span", "frontend.layouts.bottom.sign")}
              <Link to="#" className="link-blue">
                IPG
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/layout/_footer.jsx